import { useFormItemContext } from './FormItemContext';

export function useFormItemEnabled() {
  const { enabled, layoutEnabled } = useFormItemContext();

  return { enabled, layoutEnabled };
}
